import { produce } from 'immer';
import { RECEIVE_BASE_DATA, REQUEST_BASE_DATA, SET_GRID_ID_NAME, SET_GRID_INSTANCE, REQUEST_BASE_SBS_DATA, RECEIVE_BASE_SBS_DATA } from 'state/grid/actions';

const defaultState = {
  gridInstance: null,
  gridStateName: null,
  fetchingBaseData: false,
  fetchingBaseSbsData: false,
  baseData: null,
  baseSbsData: null
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_GRID_INSTANCE: {
      state.gridInstance = action.gridInstance;
      break;
    }
    case SET_GRID_ID_NAME: {
      state.gridStateName = action.gridStateName;
      break;
    }
    case REQUEST_BASE_DATA: {
      state.fetchingBaseData = true;
      state.baseData = defaultState.baseData;
      break;
    }
    case RECEIVE_BASE_DATA: {
      state.fetchingBaseData = false;
      state.baseData = action.data;
      break;
    }
    case REQUEST_BASE_SBS_DATA: {
      state.fetchingBaseSbsData = true;
      state.baseSbsData = defaultState.baseSbsData;
      break;
    }
    case RECEIVE_BASE_SBS_DATA: {
      state.fetchingBaseSbsData = false;
      state.baseSbsData = action.data;
      break;
    }

    default:
      return state;
  }
});
